import { CompanyInfoType } from './company-info-type.enum';
import { RmsUser } from '../rms-user';
import { BaseEntity } from '../../../xform-compat';

export class CompanyInfo implements BaseEntity {
  id: number;
  companyId: number;
  companyInfoType: CompanyInfoType;
  value: string;
  createdBy: RmsUser;
  updatedBy: RmsUser;
  created: Date;
  updated: Date;

  constructor(info: Partial<CompanyInfo> = {}) {
    this.id = info.id;
    this.companyId = info.companyId;
    this.companyInfoType = info.companyInfoType;
    this.value = info.value;
    this.createdBy = info.createdBy;
    this.updatedBy = info.updatedBy;
    this.created = info.created;
    this.updated = info.updated;
  }
}
